import { Country } from '../country/country';
import { Currency } from '../currency/currency';

export const FREE_SHIPPING_THRESHOLD = {
  [Country.Australia]: 55,
  [Country.Singapore]: 49,
  [Country.UnitedStates]: 49,
  [Country.Malaysia]: 170,
  [Country.Canada]: 69,
  [Country.NewZealand]: 60,
  // Temporarily disabled — shipping to Middle East countries is suspended
  // [Country.Qatar]: 215,
  // [Country.UnitedArabEmirates]: 180,
  // [Country.SaudiArabia]: 220,
  [Country.UnitedKingdom]: 45,
  [Country.Netherlands]: 45,
  [Country.Germany]: 45,
  [Country.France]: 45,
  //[Country.Spain]: 45,
  [Country.Belgium]: 45,
};

export const FREE_SHIPPING_THRESHOLD_CURRENCY = {
  [Currency.Australia]: 55,
  [Currency.Singapore]: 49,
  [Currency.UnitedStates]: 49,
  [Currency.Malaysia]: 170,
  [Currency.Canada]: 69,
  [Currency.NewZealand]: 60,
  // Temporarily disabled — shipping to Middle East countries is suspended
  // [Currency.Qatar]: 215,
  // [Currency.UnitedArabEmirates]: 180,
  // [Currency.SaudiArabia]: 220,
  [Currency.UnitedKingdom]: 45,
};
